"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormDropdown = exports.getOptionTitleByValue = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const app_1 = require("app");
const React = require("react");
const lists_1 = require("../../../../src/lists");
const FormLabel_1 = require("./FormLabel");
const getOptionTitleByValue = (options, value) => {
    const selectedOptionIndex = (0, lists_1.findIndex)(options, (element) => {
        return element.value === value;
    });
    if (selectedOptionIndex > -1) {
        return options[selectedOptionIndex].title;
    }
    const defaultOption = (0, lists_1.findIndex)(options, (element) => {
        return element.value === '' && element.hidden !== true;
    });
    if (defaultOption > -1) {
        return options[defaultOption].title;
    }
    return '';
};
exports.getOptionTitleByValue = getOptionTitleByValue;
const FormDropdown = ({ name, placeholder, label, options, hint, onChange, value, errorMessage, hasError, disabled, cssClass, required, hiddenDefaultOption = true, formControlRef, }) => {
    const extendedOptions = React.useMemo(() => [
        { title: placeholder || label || name, value: '', hidden: hiddenDefaultOption },
        ...options,
    ], [hiddenDefaultOption, label, name, options, placeholder]);
    const dropdownLabelId = (0, app_1.generateUniqueString)('label');
    const dropdownInputId = (0, app_1.generateUniqueString)('input');
    return ((0, jsx_runtime_1.jsxs)("fieldset", { className: `form-field ${cssClass || ''}`, children: [!!label && ((0, jsx_runtime_1.jsx)(FormLabel_1.FormLabel, { id: dropdownLabelId, htmlFor: dropdownInputId, title: label, required: required, disabled: disabled, hint: hint })), (0, jsx_runtime_1.jsx)("select", { id: dropdownInputId, className: `form-select` + (hasError ? ' error' : ''), onChange: onChange, name: name, value: value, disabled: disabled, "aria-labelledby": dropdownLabelId, role: "listbox", "aria-disabled": disabled, ref: formControlRef, children: extendedOptions.map((option) => ((0, jsx_runtime_1.jsx)("option", { value: option.value, hidden: option.hidden, disabled: option.disabled, role: "option", children: option.title }, option.value))) }), hasError && (0, jsx_runtime_1.jsxs)("span", { className: "error form-helper-text", children: [errorMessage, "\u00A0"] })] }));
};
exports.FormDropdown = FormDropdown;
